import domready from 'domready'
import { nodelistToArray } from './helpers/nodelistToArray'
import { init } from './init'
import './index.css'
import { root } from '../shared/App.css'
import msgStyle from '../shared/components/Message/Message.css'
const rootElementClassName = root

window[rootElementClassName] = window[rootElementClassName] || {}

const imgClass = msgStyle.message__image
const clickable = msgStyle['message__image--clickable']
const expanded = msgStyle['message__image--expanded']
const hover = msgStyle['message__image--hover']

function mountFn (el) {
  const imgs = nodelistToArray(el.querySelectorAll(`.${imgClass}`))
  imgs.map(makeExpandable)
}

const onClick = (el, className) => el.classList.toggle(className)
const onEnter = (el, className, shouldHover) => shouldHover && el.classList.add(className)
const onLeave = (el, className) => el.classList.remove(className)
const makeExpandable = el => {
  let isHoverable = true
  el.classList.add(clickable)
  el.addEventListener('click', () => onClick(el, expanded))
  el.addEventListener('touchstart', () => (isHoverable = false))
  el.addEventListener('mouseenter', () => onEnter(el, hover, isHoverable))
  el.addEventListener('mouseleave', () => onLeave(el, hover))
}
domready(() => init(rootElementClassName, mountFn))



// WEBPACK FOOTER //
// ./src/client/index.js